import React, { useState } from "react";

export default function CustomSwitch(props) {
  const [isChecked, setIsChecked] = useState(props.checked || props.isEnabled ? true : false);
  return (
    <>
      <div className="row ml-3 pb-2">
        <div className={`${props.customClass ? props.customClass : ""} ${props.variant ? props.variant : ""} custom-control custom-switch`}>
          {props.isEnabled !== undefined ? (
            <input
              checked={props.isEnabled}
              onChange={() => {
                props.setIsEnabled(!props.isEnabled);
                setIsChecked(!isChecked);
              }}
              type="checkbox"
              className="custom-control-input"
              id={props.id}
              name={props.name ? props.name : null}
              disabled={props.disabled}
            />
          ) : (
            <input
              checked={isChecked}
              onChange={() => setIsChecked(!isChecked)}
              type="checkbox"
              className="custom-control-input"
              id={props.id}
              name={props.name ? props.name : null}
              disabled={props.disabled}
            />
          )}
          <label className="custom-control-label" htmlFor={props.id}>
            {props.label}
          </label>
          <input
            className={"custom-control-input"}
            type="hidden"
            disabled={props.disabled}
            value={isChecked || props.isEnabled ? true : false}
            name={props.name ? `${props.name}` : undefined}
            ref={props.ref ? props.ref : null}
          />
        </div>
      </div>
      <div style={{ minWidth: "250px" }} className="pb-4 m-0 d-inline-block">
        {props.isEnabled !== undefined ? (
          props.isEnabled ? (
            <p className="nunito-regular f16 primary"> {props.text} is currently enabled</p>
          ) : (
            <p className="nunito-regular f16 primary"> {props.text} is currently disabled</p>
          )
        ) : isChecked ? (
          <h4 style={{ color: "#2c345b" }} className="nunito-regular">
            {" "}
            {props.text} is currently enabled
          </h4>
        ) : (
          <h4 style={{ color: "#2c345b" }} className="nunito-regular">
            {" "}
            {props.text} is currently disabled
          </h4>
        )}
      </div>
    </>
  );
}
